<wf-main-content categoryName="Enroll" [categoryIcon]="enrollIcon" toolName="Student Subscriptions">
  @let showDiagnosticSubscriptions = unassignedDiagnosticLicenses() === -1 || unassignedDiagnosticLicenses() > 0 || anyStudentHasDiagnosticSubs();
  @if (currentUser()?.userRole === UserRoles.SCHOOL_ADMIN || currentUser()?.effectiveUserRole === UserRoles.SCHOOL_ADMIN || currentUser()?.userRole === UserRoles.CUSTOMER_SERVICE) {
    <div class="tool-scope">
      <div class="filter-options">
        <wf-school-teacher-filter
          class="manage-subscriptions-school-teacher-filter"
          [districts]="districts"
          [teachers]="teachers"
          [chainLoad]="true"
          [includeAllScope]="false"
          [padding]="false"
          (filterChangeEvent)="schoolTeacherFilters.set($event)"
        />
        <wf-students-filter
          [grades]="screenerData()?.grades ?? []"
          [filterClass]="false"
          [filterExtraSupport]="false"
          [emitOnNewData]="true"
          (filterChangeEvent)="filters.set($event)"
        />
      </div>
    </div>
  }
  <div class="manage-student-subscriptions">
    <!-- <div [ngClass]="{ 'disabled-report' : schoolFilterError }"></div> -->
    <!-- {{ screenerData() | json }} -->
      <div class="manage-subscriptions-summary">
        <div class="manage-subscriptions-count-summary">
          <h3 id="resultsTableHeader" class="screener-header bold">
            Subscriptions
          </h3>
          @let subs = subscriptions();
          @if(subs) {
            @if (showDiagnosticSubscriptions) {
              @let remainingDiagnosticSubs = subs!.remaining.diagnostic;
              <wf-remaining-subscriptions subscriptionsType="diagnostic" [remaining]="remainingDiagnosticSubs"/>
            }
            @let remainingSystemSubs = subs!.remaining.system;
            <wf-remaining-subscriptions subscriptionsType="system" [remaining]="remainingSystemSubs"/>
          }
        </div>
        <div class="screener-report">
          <h3 id="resultsTableHeader" class="screener-header bold">
            Screener Results
          </h3>
          <wf-screener-results [grade]="filters().grade" [students]="studentsFilteredDisplay()"/>
        </div>
        <div class="status-overview">
          <h3 id="statusOverviewHeader" class="screener-header bold">
            Status Overview
          </h3>
          <div class="status-overview-row">
            <span class="status-overview-number status-overview-number-not-started">{{ studentsNotStarted() }}</span>
            <span class="status-overview-label">Not Started ({{ notStartedPercentage() }}%)</span>
          </div>
          <div class="status-overview-row">
            <span class="status-overview-number status-overview-number-started">{{ studentsStarted() }}</span>
            <span class="status-overview-label">Started  ({{ startedPercentage() }}%)</span>
          </div>
          <div class="status-overview-row">
            <span class="status-overview-number status-overview-number-skipped">{{ studentsSkipped() }}</span>
            <span class="status-overview-label">Skipped  ({{ skippedPercentage() }}%)</span>
          </div>
          <span class="status-overview-row-border"></span>
          <div class="status-overview-row">
            <span class="status-overview-number status-overview-number-total">{{ studentsFiltered().length }}</span>
            <span class="status-overview-label bold">Total Students</span>
          </div>
        </div>
      </div>
      <div class="scrollable-container">
        <table class="report-table">
          <colgroup>
            @if (showDiagnosticSubscriptions) {
              <col style="width: 90px"/>
            }
            <col style="width: 90px"/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
          </colgroup>
          <thead>
          <ng-template #sortableTableHeader let-column="column">
            <th class="sortable-report-table-header">
              <button
                (click)="updateSort(column)"
                [attr.aria-sort]="sortColumn().column === column ? (sortColumn().reverse ? 'desending' : 'ascending') : undefined"
              >
                {{ column }}
                <div
                  [class]=" { 'arrow-up' : sortColumn().reverse, 'arrow-down': !sortColumn().reverse }"
                  [style.visibility]="(sortColumn().column !== column) ? 'hidden' : 'visible'"
                  class="print-hide"
                ></div>
              </button>
            </th>
          </ng-template>
          <tr>
            @if(showDiagnosticSubscriptions) {
              <th>
                Diagnostic
              </th>
            }
            <th>
              System
            </th>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.STUDENT_NAME }"/>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.GRADE }"/>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.RESULTS }"/>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.DATE_STARTED }"/>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.DATE_COMPLETED }"/>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.PERCENT_COMPLETE }"/>
          </tr>
          </thead>
          <tbody>
            @for (student of studentsFilteredDisplaySorted(); track student.userID) {
              <tr>
                @let hasDiagnosticSub = selectedStudentUserIDs().diagnostic[student.userID];
                @let hasSystemSub = selectedStudentUserIDs().system[student.userID];
                @if(showDiagnosticSubscriptions) {
                  <td>
                    @if (subscriptions()?.students[student.userID]?.[1]?.consumed || hasSystemSub || !(student.assessments | allAssessmentsCompleted)) {
                      <fa-icon [icon]="lockIcon"/>
                    } @else {
                      <input
                        type="checkbox"
                        (change)="toggleSub('diagnostic', student)"
                        [checked]="hasDiagnosticSub"
                        [disabled]="!hasDiagnosticSub && subs && (subs!.remaining!.diagnostic === 0 || subs!.remaining.diagnostic === -2)"
                      />
                    }
                  </td>
                }
                <td>
                  @if (subscriptions()?.students[student.userID]?.[2]?.consumed) {
                    <fa-icon [icon]="lockIcon"/>
                  } @else {
                    <input
                      type="checkbox"
                      (change)="toggleSub('system', student)"
                      [checked]="hasSystemSub"
                      [disabled]="!hasSystemSub && subs && subs!.remaining!.system === 0"
                    />
                  }
                </td>
                <th scope="row"> {{ student.firstName }} {{ student.lastName }} </th>
                <td> {{ student.grade | displayGrade }} </td>
                <td>
                  <div class="screener-results-score" [class]="student.screenerClass">
                    @if (student.firstAssessmentScore?.dateCompleted) {
                      {{ student.scoreRange }}
                    }
                  </div>
                </td>
                <td> {{ student.firstAssessmentScore?.dateStarted | date : DATE_FORMAT }} </td>
                <td> {{ student.firstAssessmentScore?.dateCompleted | date : DATE_FORMAT }} </td>
                <td>
                  @if (student.skipped) {
                    <div class="status-skipped">SKIPPED</div>
                  } @else {
                    {{ student.percentComplete | percentRound }}
                  }
                </td>
              <tr>
            }
          </tbody>
        </table>
      </div>

  </div>

  <!-- Skip Warning Dialog -->
  @if (showConfirmDialog) {
    <div class="assign-confirm-dialog-background"></div>
    <div class="modal-dialog schedule-dialog" style="z-index: 1001;">
      <div class="modal-content">
        <div class="modal-body">
          <div class="alert alert-warning" style="margin-bottom: 20px;">
            <strong>Warning:</strong>
            <!-- @if (selectedStudents.size === 1) {
              The selected student has not completed the Screener
            } @else {
              Some of the selected students have not completed the Screener
            } -->
          </div>
          <p class="schedule-dialog-text smaller-text">
            Skipping the Screener means that a Student will not take this assessment and will not receive Screener scores.
            This action cannot be undone once performed.
          </p>
          <p class="schedule-dialog-text smaller-text">
            <!-- Are you sure you want to skip the Screener for the selected student{{ .size > 1 ? 's' : '' }}? -->
          </p>
        </div>
        <div class="confirm-dialog-bottom-container modal-footer">
          <button class="btn schedule-dialog-cancel-btn" (click)="showConfirmDialog = false"><fa-icon [icon]="cancelIcon"></fa-icon> Cancel</button>
          <!-- <button type="submit" class="btn btn-warning schedule-dialog-confirm-btn" (click)=moveSelectedStudents(confirmSkipScreenerTo)"><fa-icon [icon]="skipIcon"></fa-icon> Yes, Skip Screener</button> -->
        </div>
      </div>
    </div>
  }
</wf-main-content>
